import { render } from "./TextMediaPortrait.vue?vue&type=template&id=09e09f85"
import script from "./TextMediaPortrait.vue?vue&type=script&lang=js"
export * from "./TextMediaPortrait.vue?vue&type=script&lang=js"

import "./TextMediaPortrait.vue?vue&type=style&index=0&id=09e09f85&lang=scss"
script.render = render

export default script